import { typesPartner } from 'helpers/partner.helpers';
import { useMemo } from 'react';

import { Grid, Typography } from '@mui/material';

export const PartnerTypes: React.FC<any> = ({ types }) => {
  const typesString = useMemo(() => {
    return typesPartner(types);
  }, [types]);

  return (
    <Grid container>
      <Typography
        letterSpacing={1.35}
        fontWeight={300}
        component="legend"
        paddingRight={0.5}
      >
        TIPO DE PARCEIRO
      </Typography>

      <Typography color="black" fontWeight={400}>
        {typesString}
      </Typography>
    </Grid>
  );
};

